module.exports = __webpack_public_path__ + "img/bell.849a2129.svg";